export default "__VITE_ASSET__D2zjTI_g__"